export enum ContentType {
  JSON = "application/json",
  OCTET_STREAM = "application/octet-stream",
  PNG = "image/png",
  SVG = "image/svg+xml",
  TEXT = "text/plain; charset=utf-8",
}
